;(function(w){
	function LightboxContenidoSlider(element){
		
		var paginador = $(element).find('.slider-pagination ul')[0];
		var holder_items = $(element).find('.content-slider-holder-items')[0];

		var arr_items = [];

		$(holder_items).find('li').each(function(){
			arr_items.push(this);
			$(paginador).append('<li></li>');
		});


		setTimeout(function(){
			$(holder_items).find('li').css('opacity',1);	
		},300);
		

		var arr_paginador = [];
		
		$(element).find('.slider-pagination li').each(function(){
			arr_paginador.push(this);
			$(this).bind('click', onClickPaginadorBtn);
		})

		var ancho_item;

		var actual = 0;

		onResize();

		
		goItem(actual);

		$(window).bind('resize', onResize);


		function goItem(id){
			$(arr_paginador[actual]).removeClass('active');
			

			if($(element).data('type') == 'video'){
				var anterior = actual;
				setTimeout(function(){
					$(arr_items[anterior]).find('iframe').eq(0).attr('src', $(arr_items[anterior]).find('iframe').eq(0).attr('src'));	
				},400);
			}

			actual = id;
			$(arr_paginador[actual]).addClass('active');

			$(holder_items).css('left',-actual*ancho_item);
		}

		function onClickPaginadorBtn(e){
			goItem($(this).index());
		}

		function onResize(e){
			ancho_item = $(element).width();


			for(var i=0; i < arr_items.length;i++){
				$(arr_items[i]).css('width', ancho_item);
			}

			$(holder_items).css('width',ancho_item*arr_items.length + 20);
			$(holder_items).css('left',-actual*ancho_item);

		}

	}
	
	w.LightboxContenidoSlider = LightboxContenidoSlider;
})(window)